export function getTimezone(): string {
  return new Date().toTimeString().split('(')[1]?.split(')')[0] ?? '';
}

export function getShortZoneName(): string {
  return (new Date().toTimeString().split('(')[1]?.split(')')[0] ?? '').split(' ').filter(w => w).map(w => w[0]).join('');
}

export function getInitialsFromName(timezoneName: string): string {
  return timezoneName.split('').filter(c => c >= 'A' && c <= 'Z').join('');
}
